/**
 * Utility function to get the dialog container element
 * This ensures dialogs render within the AppGrid main content area
 */
export const getDialogContainer = (): HTMLElement | undefined => {
  return document.getElementById('dialog-container') || undefined;
};
